export default [
  {
    path: '/mall',
    component: resolve => require(['@/views/index/Index.vue'], resolve),
    meta: {
      pageId: 'index'
    }
  },
  {
    path: '/mall/new-in',
    component: resolve => require(['@/views/commodity/components/NewIn.vue'], resolve),
    meta: {
      pageId: 'index_newIn'
    }
  },
  {
    path: '/mall/sale',
    component: resolve => require(['@/views/commodity/components/Sale.vue'], resolve),
    meta: {
      pageId: 'index_sale'
    }
  },
  {
    path: '/product-list',
    component: resolve => require(['@/views/index/ProductList.vue'], resolve),
    meta: {
      pageId: 'index_productList'
    }
  },
  {
    path: '/product-list/:menu',
    component: resolve => require(['@/views/index/ProductList.vue'], resolve),
    meta: {
      pageId: 'index_productList'
    }
  },
  {
    path: '/product-list/:menu/:param',
    component: resolve => require(['@/views/index/ProductList.vue'], resolve),
    meta: {
      pageId: 'index_productList'
    }
  },
  // {
  //   path: '/commodity/product-detail', // 现货/详情
  //   component: resolve => require(['@/views/commodity/ProductDetail.vue'], resolve),
  //   meta: {
  //     pageId: 'index_productDetail'
  //   }
  // },
  {
    path: '/product-detail/:menu/:param', // 现货/详情
    component: resolve => require(['@/views/commodity/ProductDetail.vue'], resolve),
    meta: {
      pageId: 'index_productDetail'
    }
  },
  {
    path: '/confirm-order', // 确认订单
    component: resolve => require(['@/views/commodity/ConfirmOrder.vue'], resolve),
    meta: {
      pageId: 'index_confirmOrder'
    }
  },
  {
    path: '/payment-status', // 订单支付状态
    component: resolve => require(['@/views/commodity/PaymentStatus.vue'], resolve),
    meta: {
      pageId: 'index_paymentStatus'
    }
  },
  {
    path: '/mall/similar',
    component: resolve => require(['@/views/index/Similar.vue'], resolve),
    meta: {
      isKeep: true,
      pageId: 'index_similar'
    }
  },
  {
    path: '/mall/discount', // 折扣
    component: resolve => require(['@/views/index/discount.vue'], resolve),
    meta: {
      pageId: 'index_discount'
    }
  },
  {
    path: '/mall/flash-sale', // 现货/详情
    component: resolve => require(['@/views/index/FlashSale.vue'], resolve),
    meta: {
      pageId: 'index_flashSale'
    }
  },
  {
    path: '/mall/shipping-cost', // 计算运费
    component: resolve => require(['@/views/index/ShippingCost.vue'], resolve),
    meta: {
      pageId: 'index_shippingCost'
    }
  },
  {
    path: '/mall/explore',
    component: resolve => require(['@/views/index/Explore.vue'], resolve),
    meta: {
      isKeep: true,
      pageId: 'index_explore'
    }
  },
  {
    path: '/mall/explore/detail',
    component: resolve => require(['@/views/index/MobileExploreDetail.vue'], resolve),
    meta: {
      pageId: 'index_exploreDetail'
    }
  },
  {
    path: '/mall/search',
    component: resolve => require(['@/views/index/MobileSearchCenter.vue'], resolve),
    meta: {
      pageId: 'index_search'
    }
  },
  // {
  //   path: '/commodity/category-detail', // 品类详情
  //   component: resolve => require(['@/views/commodity/CategoryDetail.vue'], resolve)
  // },
  {
    path: '/mall/festival-collection', // 节日专区
    component: resolve => require(['@/views/index/FestivalCollection.vue'], resolve),
    meta: {
      pageId: 'index_festivalCollection'
    }
  },
  {
    path: '/mall/shoppingCar', // 购物车
    component: resolve => require(['@/views/index/ShoppingCar.vue'], resolve),
    meta: {
      pageId: 'index_shippingCar'
    }
  },
  {
    path: '/mall/mobileCart', // 移动端购物袋
    component: resolve => require(['@/views/index/MobileCart.vue'], resolve),
    meta: {
      pageId: 'index_mobileCart'
    }
  },
  {
    path: '/mall/paymentPage', // 支付页面
    component: resolve => require(['@/views/index/PaymentPage.vue'], resolve),
    meta: {
      pageId: 'index_paymentPage'
    }
  },
  {
    path: '/mall/album', // 专辑页面
    component: resolve => require(['@/views/index/album/Index.vue'], resolve),
    meta: {
      pageId: 'index_album'
    }
  },
  // {
  //   path: '/attr', // 聚合分类
  //   component: resolve => require(['@/views/index/polymerize/Index.vue'], resolve),
  //   meta: {
  //     pageId: 'index_polymerize'
  //   }
  // },
  // {
  //   path: '/attr/:params', // 聚合分类产品
  //   component: resolve => require(['@/views/index/polymerize/Product.vue'], resolve),
  //   meta: {
  //     pageId: 'index_polymerizeProduct'
  //   }
  // },
  // 404 页面
  {
    path: '/404',
    component: (resolve) => require(['@/views/index/404.vue'], resolve),
    meta: {
      pageId: 'index_404'
    }
  }
]
